import { render, staticRenderFns } from "./CompanyChangePopover.vue?vue&type=template&id=4b30b513&scoped=true"
import script from "./CompanyChangePopover.vue?vue&type=script&lang=ts"
export * from "./CompanyChangePopover.vue?vue&type=script&lang=ts"
import style0 from "./CompanyChangePopover.vue?vue&type=style&index=0&id=4b30b513&prod&lang=less&scoped=true"
import style1 from "./CompanyChangePopover.vue?vue&type=style&index=1&id=4b30b513&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30b513",
  null
  
)

export default component.exports